/*
 * Copyright (c) 2018-2023 MemberCenter, a subsidiary of Cameron Collective
 *   All Rights Reserved
 */
import { createTheme } from '@mui/material/styles';

import palette from './palette';

const theme = createTheme({
	palette
});

export default theme;
